module.exports = __webpack_public_path__ + "img/ic_next.0eac219f.svg";